import type { AthleteItem } from '../services/api';

function workoutTimestamp(athlete: AthleteItem): number {
  if (!athlete.last_workout_uploaded_at) return 0;
  const timestamp = Date.parse(athlete.last_workout_uploaded_at);
  return Number.isFinite(timestamp) ? timestamp : 0;
}

/** Coach default: athlete who most recently uploaded or completed a workout. */
export function pickDefaultAthleteId(athletes: AthleteItem[], preferredId?: number | null): number | null {
  if (preferredId != null && athletes.some((athlete) => athlete.id === preferredId)) return preferredId;
  if (athletes.length === 0) return null;

  return athletes.reduce((latest, athlete) =>
    workoutTimestamp(athlete) > workoutTimestamp(latest) ? athlete : latest,
  ).id;
}
